import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { MultiselectDropdownComponent } from '../../../../shared/components/multiselect-dropdown/multiselect-dropdown.component';
import { USER_ROLES_OPTIONS } from '../../../../shared/constants/constants';
import { DropDownConfig } from '../../../../shared/models/multiselect-dropdown.model';
import { UserPayloadModel } from '../../../../shared/models/user.model';
import { UserService } from '../../../../shared/services/user.service';
import { SharedModule } from '../../../../shared/shared.module';
@Component({
  selector: 'app-add-edit-user',
  standalone: true,
  imports: [
    SharedModule,
    ButtonComponent,
    ButtonLoaderComponent,
    NgxMaskDirective,
    InputWrapperComponent,
    MultiselectDropdownComponent,
  ],
  templateUrl: './add-edit-user.component.html',
  styleUrl: './add-edit-user.component.scss',
  providers: [provideNgxMask()],
})
export class AddEditUserComponent implements OnInit {
  userForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required]],
    role: [USER_ROLES_OPTIONS[0], [Validators.required]],
  });
  isLoading: boolean = false;
  roles = USER_ROLES_OPTIONS;
  roleDropdownSettings: DropDownConfig = {
    allowSearchFilter: true,
    title: 'Role',
    placeholder: 'Select Role',
    searchPlaceholderText: '',
    allowPagination: true,
    required: true,
  };
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    if (!this.userForm.valid || this.isLoading) {
      this.userForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    const payload: UserPayloadModel = {
      ...this.userForm.value,
      role: this.userForm.value?.role?.value,
    };
    this.userService.createUser(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.router.navigate(['/users']);
        this.toastr.success('User added successfully');
      },
      error: (err) => {
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
        this.isLoading = false;
      },
    });
  }

  handleClose() {
    this.router.navigate(['/users']);
  }
}
